/**
 * @file App.js
 * @description Main application component. Sets up routing and global configurations such as Toast notifications.
 * @author govind dindewad
 */

import logo from './logo.svg'; // Unused import, consider removing if not needed
import './App.css'; // Global CSS styles for the App
import RoutingComponent from './Routes'; // Component that handles all route configurations
import { BrowserRouter } from 'react-router'; // Router for handling client-side navigation
import { ToastContainer } from 'react-toastify'; // Toast notification container

/**
 * @function App
 * @description Root component of the application. Wraps all components with routing and toast notifications.
 * @returns {JSX.Element}
 */

function App() {
  return (
    <div className="App">
      {/* Set up client-side routing using BrowserRouter */}
      <BrowserRouter>

        {/* Configure the ToastContainer for global notifications */}
        <ToastContainer
          position="bottom-right"       // Position of toast
          autoClose={5000}              // Auto close after 5 seconds
          hideProgressBar={false}       // Show progress bar
          newestOnTop={true}            // Newest toast appears on top
          closeOnClick                  // Allow toast to be closed on click
          rtl={true}                    //
          //  Right-to-left layout for languages like Arabic or Hebrew
          pauseOnFocusLoss              // Pause autoClose when focus is lost
          draggable                     // Allow toast to be dragged
          pauseOnHover                  // Pause autoClose on hover
          theme="light"                 // Use light theme
        />

        {/* All route handling is done inside this component */}
        <RoutingComponent />

      </BrowserRouter>
    </div>
  );
}

export default App;
